import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import PaymentEvents from 'shared/components/payment-events/payment-events';
import {
  clearVideoUrlsCacheForAll,
  clearVideoUrlsCacheForItem,
} from 'widget/redux/client/actions/video-urls/clear';


@connect(null, {
  clearVideoUrlsCacheForAll,
  clearVideoUrlsCacheForItem,
})
export default class ClearVideoUrlsCacheOnPayment extends React.Component {
  static propTypes = {
    clearVideoUrlsCacheForAll: React.PropTypes.func,
    clearVideoUrlsCacheForItem: React.PropTypes.func,
  };

  @autobind
  @debounce
  clearVideoUrlsCacheForAll() {
    this.props.clearVideoUrlsCacheForAll();
  }

  @autobind
  clearVideoUrlsCacheForItem(data) {
    this.props.clearVideoUrlsCacheForItem(data.itemId);
  }

  render() {
    return (
      <PaymentEvents onSubscription={this.clearVideoUrlsCacheForAll}
                     onSubscriptionCancel={this.clearVideoUrlsCacheForAll}
                     onRent={this.clearVideoUrlsCacheForItem}
                     onSale={this.clearVideoUrlsCacheForItem} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/clear-video-urls-cache-on-payment.js